import React from 'react'

const FinanceDivider = () => (
  <>
    <span className="bg-gray-40 h-full inset-0 m-auto absolute w-px" />
    <span className="text-body-xs bg-white relative z-10 p-1 flex">or</span>
  </>
);


export default FinanceDivider
